<template>
  <div class="bk">
    <el-container style="background-color: #262696;">
      <Content>
        <div>
          <h1>大数据词云</h1>
          <h5>用大数据生成真正值得分享的词云图</h5>
        </div>
        <div style="width: 600px;margin:50px auto 20px;">
          <Search/>
        </div>
      </Content>
    </el-container>
    <Content>
      <h3 class="title">
        用户分享大数据词云
      </h3>
      <div class="morelink" @click="$router.push(`/list`)">查看更多>></div>
      <el-row :gutter="15">
        
        <el-col :span="4.8" v-for="(item,index) in list" :key="item.id" :offset="index>0?0:0">
          <CloudCard :item="item"></CloudCard>
        </el-col>
      </el-row>
      <div style="text-align: center;margin-top: 10px;margin-bottom: 20px;">
        <el-button type="primary" @click="$router.push(`/list`)">查看更多
        <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </content>
  </div>
</template>

<script>
    import Search from "../components/share/Search"
    import {mapActions, mapMutations} from "vuex"

    export default {
        name: "Index",
        data() {
            return {
                list: []
            }
        },
        components: {
            Search
        },
        mounted() {
            this.MSetMenu("/");
            this.getList();
        },
        methods: {
            ...mapActions("core", ["AList"]),
            ...mapMutations("menu", ["MSetMenu"]),
            async getList() {
                // this.loading = true
                let params = {position: 'FirstPages'};
                let result = await this.AList(params);
                /* eslint-disable no-alert, no-console */
                // eslint-disable-next-line no-console
                //console.log(result)
                // this.loading = false
                // console.log(result)
                //TODO
                // console.log(typeof result.errorCode)
                if (!result.errorCode) {
                    //TODO
                    this.list = result.data.dataSource;
                }
            }
        }
    }
</script>
<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  h1 {
    color: white;
    text-align: center;
    font-size: 40px;
    font-weight: 500;
  }

  h5 {
    color: white;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
  }

  .title {
    padding: 20px 0;
    font-size: 16px;
    font-weight: 400;
  }
  .morelink{
    float: right;
    margin-top: -35px;
    font-size: 14px;
    color: #8e8888;
    cursor: pointer;
  }

</style>
